import React, { HTMLProps } from 'react';
import cx from 'classnames';
import styles from './Form.module.css';

type Props<T> = {
  error?: boolean;
} & HTMLProps<T>;

export function FieldSet({
  error,
  className,
  ...props
}: Props<HTMLFieldSetElement>) {
  return (
    <fieldset
      {...props}
      className={cx(styles.fieldSet, error && styles.hasError, className)}
    />
  );
}

export function HelperText({
  error,
  className,
  ...props
}: Props<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={cx(styles.helperText, error && styles.hasError, className)}
    />
  );
}

export function Label({ error, className, ...props }: Props<HTMLLabelElement>) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      {...props}
      className={cx(
        'dsm-form-label-text',
        styles.label,
        error && styles.hasError,
        className
      )}
    />
  );
}

export function Legend({
  error,
  className,
  ...props
}: Props<HTMLLegendElement>) {
  return (
    <legend
      {...props}
      className={cx(
        !className && 'dsm-form-label-text',
        styles.legend,
        error && styles.hasError,
        className
      )}
    />
  );
}

export function TextErrorMessage({
  className,
  ...props
}: Props<HTMLParagraphElement>) {
  return (
    <p
      {...props}
      className={cx(styles.errorText, styles.textErrorMessage, className)}
    />
  );
}
